import { render, staticRenderFns } from "./PictureRepository2.vue?vue&type=template&id=6d86daca&scoped=true&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./PictureRepository2.vue?vue&type=script&lang=js&"
export * from "./PictureRepository2.vue?vue&type=script&lang=js&"
import style0 from "./PictureRepository2.vue?vue&type=style&index=0&id=6d86daca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d86daca",
  null
  
)

export default component.exports